// The two tabs of the Pricing screen. Archived plans are `enabled: false` on
// the API; they keep renewing their subscribers but are hidden from the
// community home and the checkout.
export const PLAN_TABS = {
  ACTIVE: "active",
  ARCHIVED: "archived",
};

export const DEFAULT_PLAN_TAB = PLAN_TABS.ACTIVE;

// Built from the caller's `t` so labels follow the active language.
export const getPlanTabs = (t) => [
  { key: PLAN_TABS.ACTIVE, label: t("pricing.tabs.active") },
  { key: PLAN_TABS.ARCHIVED, label: t("pricing.tabs.archived") },
];

export function isPlanArchived(plan) {
  return plan?.enabled === false;
}
